var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var Owner;
(function (Owner) {
    Owner["User"] = "User";
    Owner["Bot"] = "Bot";
    Owner["Agent"] = "Agent";
    Owner["System"] = "System";
})(Owner || (Owner = {}));
var ChatbotService = /** @class */ (function () {
    function ChatbotService(options) {
        this.options = options;
    }
    ChatbotService.prototype.reply = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var replyBody, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        replyBody = {
                            message: args.text,
                            chatId: args.chatId,
                            meta: args.meta,
                        };
                        return [4 /*yield*/, fetch(this.options.endpoint + "/bot", {
                                method: "POST",
                                headers: this.headers(),
                                body: JSON.stringify(replyBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = (_a.sent());
                        return [2 /*return*/, data.messages.map(function (m) { return ({
                                id: data.assistantMessageId || undefined,
                                text: m,
                                timestamp: Date.now(),
                                owner: Owner.Bot,
                                action: data.action,
                            }); })];
                }
            });
        });
    };
    ChatbotService.prototype.feedback = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.options.endpoint + "/feedback", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                chatId: args.chatId,
                                messageIndex: args.messageIndex,
                                messageId: args.messageId,
                                feedback: args.feedback,
                            }),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatbotService.prototype.action = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var actionBody, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionBody = {
                            type: args.type,
                            chatId: args.chatId,
                            meta: args.meta,
                            data: args.data,
                        };
                        return [4 /*yield*/, fetch(this.options.endpoint + "/action", {
                                method: "POST",
                                headers: this.headers(),
                                body: JSON.stringify(actionBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = (_a.sent());
                        return [2 /*return*/, data.messages.map(function (m) { return ({
                                text: m,
                                timestamp: Date.now(),
                                owner: Owner.Bot,
                                action: data.action,
                            }); })];
                }
            });
        });
    };
    ChatbotService.prototype.init = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var actionBody, response, data, chatId, messages, previousChat;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionBody = {
                            meta: args.meta,
                            chatId: args.chatId,
                        };
                        return [4 /*yield*/, fetch(this.options.endpoint + "/init", {
                                method: "POST",
                                headers: this.headers(),
                                body: JSON.stringify(actionBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = (_a.sent());
                        chatId = args.chatId;
                        messages = [];
                        if (data.history) {
                            previousChat = data.history[0];
                            if (previousChat) {
                                chatId = previousChat.chatId;
                            }
                            data.history.forEach(function (chat) {
                                chat.messages.reverse().forEach(function (msg) {
                                    messages.push({
                                        text: msg.message,
                                        timestamp: new Date(msg.timestamp).getTime(),
                                        owner: msg.isUser ? Owner.User : Owner.Bot,
                                        action: data.action,
                                    });
                                });
                            });
                        }
                        return [2 /*return*/, { chatId: chatId, messages: messages }];
                }
            });
        });
    };
    ChatbotService.prototype.headers = function () {
        var headers = {
            "Content-Type": "application/json",
        };
        if (this.options.token) {
            headers.Authorization = "Bearer ".concat(this.options.token);
        }
        return headers;
    };
    return ChatbotService;
}());
export default ChatbotService;
